<app-header></app-header>
<!--=========== breadcumb Area ============-->
<div class="breadcumb-wrapper " data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Service Details</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="index.html">Home</a></li>
                <li>Service Details</li>
            </ul>
        </div>
    </div>
</div>
<!--=========== Service Area ============-->
<section class="space">
    <div class="container">
        <div class="row">
            <div class="col-xxl-8 col-lg-7">
                <div class="page-single">
                    <div class="service-img sv-details-img">
                        <img class="w-100" src="assets/img/service/sv-details.jpg" alt="">
                    </div>
                    <div class="page-content sv-content d-block">
                        <h2 class="box-title">IT Strategy & Planning</h2>
                        <p class="box-text mb-30">In today’s fast-evolving digital landscape, businesses need a clear IT
                            strategy to align technology with their long-term goals. IT Strategy & Planning services
                            help organizations optimize resources, improve efficiency, enhance security, and drive
                            innovation through a structured approach to technology adoption and management. A
                            well-defined IT strategy ensures that businesses stay ahead of the competition by leveraging
                            the right technology, at the right time, with the right investment.</p>
                        <p class="box-text mb-50">With the rise of cloud computing, AI, cybersecurity threats, and
                            digital transformation, businesses must continuously refine their IT strategies. An
                            adaptive, forward-thinking approach ensures long-term success in a technology-driven world.
                        </p>
                        <h2 class="box-title">Why Choose The Service</h2>
                        <div class="checklist tick-checklist sv-details-list mb-40">
                            <ul>
                                <li>
                                    Visit most popular location of Maldives
                                </li>
                                <li>
                                    Buffet Breakfast for all traveler with good quality.
                                </li>
                                <li>
                                    Expert guide always guide you and give informations.
                                </li>
                                <li>
                                    Best Hotel for all also great food.
                                </li>
                                <li>
                                    Helping all traveler for Money Exchange.
                                </li>
                                <li>
                                    Buffet Breakfast for all traveler with good quality..
                                </li>
                                <li>
                                    Buffet Breakfast for all traveler with good quality.
                                </li>
                            </ul>
                        </div>
                        <div class="sv-gallery-wrapper">
                            <div class="row gy-4">
                                <div class="col-6">
                                    <div class="sv-sm-img">
                                        <img class="w-100" src="assets/img/service/sv-sm-1.jpg" alt="Blog Image">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="sv-sm-img">
                                        <img class="w-100" src="assets/img/service/sv-sm-2.jpg" alt="Blog Image">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xxl-4 col-lg-5">
                <aside class="sidebar-area">
                    <div class="widget widget_categories  ">
                        <h3 class="widget_title">Categories</h3>
                        <ul>
                            <li>
                                <a href="blog.html">IT Strategy & Planning</a>
                                <span><i class="fa-regular fa-arrow-up-right"></i></span>
                            </li>
                            <li>
                                <a href="blog.html">Web Developments</a>
                                <span><i class="fa-regular fa-arrow-up-right"></i></span>
                            </li>
                            <li>
                                <a href="blog.html">Cloud Consulting</a>
                                <span><i class="fa-regular fa-arrow-up-right"></i></span>
                            </li>
                            <li>
                                <a href="blog.html">Machine Learning</a>
                                <span><i class="fa-regular fa-arrow-up-right"></i></span>
                            </li>
                            <li>
                                <a href="blog.html">Database Security</a>
                                <span><i class="fa-regular fa-arrow-up-right"></i></span>
                            </li>
                            <li>
                                <a href="blog.html">IT Management</a>
                                <span><i class="fa-regular fa-arrow-up-right"></i></span>
                            </li>
                        </ul>
                    </div>
                    <div class="widget widget_download  ">
                        <h4 class="widget_title">Download Brochure</h4>
                        <div class="donwload-media-wrap">
                            <div class="download-media">
                                <div class="download-media_icon">
                                    <i class="fa-light fa-file-pdf"></i>
                                </div>
                                <div class="download-media_info">
                                    <h5 class="download-media_title"><a href="#">Download PDF</a></h5>
                                </div>
                            </div>
                            <div class="download-media">
                                <div class="download-media_icon">
                                    <i class="fal fa-file-lines"></i>
                                </div>
                                <div class="download-media_info">
                                    <h5 class="download-media_title"><a href="#">Download DOC</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="widget widget_banner  " data-bg-src="assets/img/bg/widget_banner.jpg">
                        <div class="widget-banner position-relative text-center">
                            <span class="icon"><i class="fa-solid fa-phone"></i></span>
                            <span class="text">Need Help? Call Here</span>
                            <a class="phone" href="tel:+25669872564">+256 6987 2564</a>
                            <a routerLink="contact" class="th-btn style6">Get A Quote <i
                                    class="fa-light fa-arrow-right-long"></i></a>
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    </div>
</section>

<!--======== Footer Section ========-->
<app-footer></app-footer>